module.exports = __webpack_public_path__ + "resources/img/img-deep-security-02-2.5547cf8f8981bf84d9d9a906e1d999b3.png";